// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d57c246c","732":"c30e1ca8","977":"7b07e592"}[chunkId] + ".chunk.js";
};